import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";
import { fmt } from "@/lib/dates";
import { Panel, Loader, Avatar } from "@/components/common";

const SHORT = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];

const Cell = ({ d }) => {
  if (!d.available) return <span className="inline-block rounded-md bg-slate-100 text-slate-400 px-2 py-0.5 text-xs">Niet</span>;
  if (d.start && d.end) return <span className="inline-block rounded-md bg-[#E6F0EC] text-[#0D5C46] px-2 py-0.5 text-xs font-mono-num">{d.start}–{d.end}</span>;
  return <span className="inline-block rounded-md bg-[#E6F0EC] text-[#0D5C46] px-2 py-0.5 text-xs">Hele dag</span>;
};

export const TeamAvailability = () => {
  const api = useApi();
  const [team, setTeam] = useState(null);

  useEffect(() => {
    api.get("/availability").then((r) => setTeam(r.data));
  }, [api]);

  return (
    <Panel className="mt-6 p-0 overflow-x-auto" data-testid="team-availability">
      <div className="p-5 pb-2">
        <h2 className="font-semibold text-lg">Beschikbaarheid van het team</h2>
        <p className="text-sm text-slate-500">Alleen zichtbaar voor eigenaar en managers. "Rooster met AI" houdt hier rekening mee.</p>
      </div>
      {!team ? <Loader /> : (
        <table className="w-full min-w-[760px] text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-xs font-semibold uppercase tracking-wider text-slate-500">
              <th className="text-left p-3">Medewerker</th>
              {SHORT.map((s) => <th key={s} className="p-3 text-left">{s}</th>)}
              <th className="p-3 text-left">Vrij gevraagd</th>
            </tr>
          </thead>
          <tbody>
            {team.map((t) => (
              <tr key={t.user_id} className="border-b border-slate-100 last:border-0 align-top" data-testid={`team-avail-row-${t.user_id}`}>
                <td className="p-3">
                  <div className="flex items-center gap-2"><Avatar name={t.name} size="h-8 w-8" /><span className="font-medium">{t.name}</span></div>
                  {!t.updated_at && <p className="text-[11px] text-amber-600 mt-1">Nog niet ingevuld</p>}
                  {t.note && <p className="text-[11px] text-slate-500 mt-1 max-w-[180px]">{t.note}</p>}
                </td>
                {t.days.map((d) => <td key={d.weekday} className="p-3"><Cell d={d} /></td>)}
                <td className="p-3 text-xs text-slate-600">{t.unavailable_dates.length ? t.unavailable_dates.slice(0, 4).map((x) => fmt(x.date, "d MMM")).join(", ") + (t.unavailable_dates.length > 4 ? " …" : "") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Panel>
  );
};
